// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 44,
  argument: "The praises of the holy fathers, in particular of Henoch, Noe, Abraham, Isaac, and Jacob.",
  verses: [
    { n: 1, text: "Let us now praise men of renown, and our fathers in their generation." },
    { n: 2, text: "The Lord hath wrought great glory through his magnificence, from the beginning." },
    { n: 3, text: "Such as have borne rule in their dominions, men of great power, and endued with their wisdom, shewing forth in the prophets the dignity of prophets," },
    { n: 4, text: "And ruling over the present people, and by the strength of wisdom instructing the people in most holy words." },
    { n: 5, text: "Such as by their skill sought out musical tunes, and published canticles of the scriptures." },
    { n: 6, text: "Rich men in virtue, studying beautifulness: living at peace in their houses." },
    { n: 7, text: "All these have gained glory in their generations, and were praised in their days." },
    { n: 8, text: "They that were born of them have left a name behind them, that their praises might be related:" },
    { n: 9, text: "And there are some, of whom there is no memorial: who are perished, as if they had never been: and are born, as if they had never been born, and their children with them." },
    { n: 10, text: "But these were men of mercy, whose godly deeds have not failed:" },
    { n: 11, text: "Good things continue with their seed," },
    { n: 12, text: "Their posterity are a holy inheritance, and their seed hath stood in the covenants:" },
    { n: 13, text: "And their children for their sakes remain for ever: their seed and their glory shall not be forsaken." },
    { n: 14, text: "Their bodies are buried in peace, and their name liveth unto generation and generation." },
    { n: 15, text: "Let the people shew forth their wisdom, and the church declare their praise." },
    { n: 16, text: "Henoch pleased God, and was translated into paradise, that he may give repentance to the nations." },
    { n: 17, text: "Noe was found perfect, just, and in the time of wrath he was made a reconciliation." },
    { n: 18, text: "Therefore was there a remnant left to the earth, when the flood came." },
    { n: 19, text: "The covenants of the world were made with him, that all flesh should no more be destroyed with the flood." },
    { n: 20, text: "Abraham was the great father of a multitude of nations, and there was not found the like to him in glory, who kept the law of the Most High, and was in covenant with him." },
    { n: 21, text: "In his flesh he established the covenant, and in temptation he was found faithful." },
    { n: 22, text: "Therefore, by an oath he gave him glory in his posterity, that he should increase as the dust of the earth," },
    { n: 23, text: "And that he would exalt his seed as the stars, and they should inherit from sea to sea, and from the river to the ends of the earth." },
    { n: 24, text: "And he did in like manner with Isaac, for the sake of Abraham, his father." },
    { n: 25, text: "The Lord gave him the blessing of all nations, and confirmed his covenant upon the head of Jacob." },
    { n: 26, text: "He acknowledged him in his blessings, and gave him an inheritance, and divided him his portion in twelve tribes." },
    { n: 27, text: "And he preserved for him men of mercy, that found grace in the eyes of all flesh." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Greek prefixes, \"A Hymn of the Fathers.\" The author here imitates the third work of Solomon. (Haydock) — He had given rules for all virtues; and he now sets before us those who had put them in practice. (Calmet) — It was the custom to sound forth the praises of these fathers in the temple and synagogues,", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Glory. Greek adds, \"in them.\" He was the author of all their virtue, (Haydock) and has acquired much glory by their means, (Calmet) among men; though his essential glory can never increase.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "In the. Greek, \"futurity by their predictions.\" Kings, judges, and prophets are praised. (Haydock) — The virtuous are justly styled kings, Genesis xxiii.", attribution: "Worthington" }
    ] },
    { verse: 4, notes: [
      { text: "The present. Greek, \"the people by counsels, and by the knowledge of the office of scribes of the people. Wise in speech by their instruction. (5.) Seeking out,\" &c. (Haydock) — Prudence and eloquence ought to appear in a ruler.", attribution: "Haydock" }
    ] },
    { verse: 5, notes: [
      { text: "Tunes. The Hebrews, and David in particular, were famous for music.", attribution: "Calmet" }
    ] },
    { verse: 6, notes: [
      { text: "In. Greek, \"established in power, living,\" &c., (Haydock) like Abraham, Ezechias, &c.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Generations. Literally, \"races of their nation.\" But this is omitted in Greek.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Born. Greek, \"some of them have left a name,\" (Haydock) or posterity, Deuteronomy xxv. 6.", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Them. This may be understood of the wicked Israelites, or of the sons of Abraham by Agar, &c.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Mercy. Assideans, (1 Paralipomenon vi. 41., and 1 Machabees vii. 13.) or true Israelites.", attribution: "Haydock" }
    ] },
    { verse: 14, notes: [
      { text: "Peace. The Jews were very solicitous about this, Genesis xxxv. 8.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Into. Greek, \"a model of penance to past or future generations.\" (Haydock) — The Latin fathers suppose that Henoch was translated to heaven, or to the earthly paradise. It is the tradition both of Jews and of Christians that he is still alive, and will come to oppose Antichrist, (Apocalypse xi. 3., Genesis v. 22., and Hebrews xi. 5.; Calmet) when he will preach penance, (Worthington) chiefly to the Gentiles, while Elias will address himself to the Jews.", attribution: "Haydock" }
    ] },
    { verse: 17, notes: [
      { text: "A. Greek, \"an exchange,\" to save mankind, Genesis vi. 8., and viii. 21. (Calmet) — Noe[Noah] was perfect, (Worthington) which does not exclude some human failings.", attribution: "Haydock" }
    ] },
    { verse: 20, notes: [
      { text: "Multitude. His name implies as much. (Calmet) — He was father of all who believed in Christ.", attribution: "Worthington" }
    ] },
    { verse: 21, notes: [
      { text: "Faithful. He received the sign of circumcision, and was ready to sacrifice Israel.", attribution: "Calmet" }
    ] },
    { verse: 22, notes: [
      { text: "In his. Greek, \"that the nations should be blessed in his posterity.\" — Dust. Literally, \"a heap.\" (Haydock)", attribution: "Genesis xii. 2., and xxii. 17." }
    ] },
    { verse: 23, notes: [
      { text: "Earth. In Arabia, and from the Red Sea to the Euphrates. This was verified in David, Psalm lxxi., and Genesis xiii. 14.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Jacob. The promises made to Abraham were confirmed to Isaac and Jacob. (Haydock) — These were also blessed in Abraham.", attribution: "Worthington" }
    ] },
    { verse: 26, notes: [
      { text: "Tribes. Giving him so many children, who inherited Chanaan.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Men. The Israelites,", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
